import React, { useContext } from "react";
import ProductContext from "../ProductContext";

const Test = () => {
  const { products, categories, onlineUsers, loading } = useContext(ProductContext);

  if (loading) {
    return <p>Carregando dados...</p>;
  }

  return (
    <div>
      <h1>Test</h1>
      <p>Usuários Online: {onlineUsers}</p>
      <h2>Categorias</h2>
      <ul>
        {categories.map((category) => (
          <li key={category._id}>{category.name}</li>
        ))}
      </ul>
      <h2>Produtos</h2>
      <ul>
        {products.map((product) => (
          <li key={product._id}>
            {product.name} - R$ {product.price.toFixed(2)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Test;
